module.exports = __webpack_public_path__ + "img/banner8.d4055b54.jpg";